var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import cx from "classnames";
import "./Typography.scss";
export const Typography = (_a) => {
    var { type = "body", component, children, className, variant } = _a, props = __rest(_a, ["type", "component", "children", "className", "variant"]);
    const Component = component || typeMapping[type];
    const classes = cx(className, "typography", `typography--${type}`, variant && `typography--${variant}`);
    return (React.createElement(Component, Object.assign({ className: classes }, props), children));
};
const typeMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    body: "p",
    "body-small": "p",
    "display-large": "h2",
    "display-small": "h2",
    label: "span",
    "label-large": "span",
    "label-small": "span",
    "label-tiny": "span",
};
export function typographyTextToProps(value) {
    if (typeof value === "string") {
        return { children: value };
    }
    const { text: children } = value, rest = __rest(value, ["text"]);
    return Object.assign({ children }, rest);
}
